import { Modal } from '../../../components/ui'
import { Button } from '../../../components/ui/legacy'
function DeleteAccountModal({ onCancel, onAccept }) {
  return (
    <Modal
      onClose={onCancel}
      className={'w-[200] rounded-md border-[1px] bg-white'}
    >
      <h1 className="mx-4 mb-2 mt-4 text-xl font-bold">
        Xác nhận xóa tài khoản?
      </h1>
      <p className="mx-4">Thao tác này không thể hoàn tác!</p>
      <div className="my-4 flex w-full items-center justify-center gap-2 px-4">
        <Button variant={'tertiary'} onClickHandler={onCancel}>
          Hủy
        </Button>
        <Button variant={'primary'} onClickHandler={onAccept}>
          Xác nhận
        </Button>
      </div>
    </Modal>
  )
}
export default DeleteAccountModal
